const sentEvents = new Set();
const responseEventIds = new WeakMap();

// Both CRM endpoints return success: true only after saving the record.
export function isLeadCreatedResponse({ status, data } = {}) {
  return (status === 200 || status === 201) && data?.success === true;
}

export function trackLeadCreatedResponse(response) {
  if (!isLeadCreatedResponse(response)) return false;
  if (typeof window === "undefined" || typeof window.oaiq !== "function") return false;

  // Analytics must never turn a saved enquiry into a failed form submission.
  try {
    const recordId = response.data.data?._id;
    // The contact-details endpoint does not return a record ID.
    let eventId = responseEventIds.get(response);
    if (!eventId) {
      eventId = `lead_created_${recordId || window.crypto?.randomUUID?.() || `${Date.now()}_${Math.random().toString(36).slice(2)}`}`;
      responseEventIds.set(response, eventId);
    }
    if (sentEvents.has(eventId)) return false;
    window.oaiq("measure", "lead_created", { type: "customer_action" }, {
      event_id: eventId,
    });
    sentEvents.add(eventId);
    return true;
  } catch {
    return false;
  }
}

// Use only for lead creation requests, never lookups or contact upserts.
export async function createLeadWithTracking(url, options) {
  const response = await fetch(url, options);
  const data = await response.clone().json();
  const result = { status: response.status, data };
  if (!isLeadCreatedResponse(result)) {
    throw new Error("Lead submission failed. Please try again.");
  }
  trackLeadCreatedResponse(result);
  return response;
}
